import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'globalSearch',standalone: false })
export class GenericLogSearchPipe implements PipeTransform {
  transform(logs: any[], searchText: string): any[] {
    if (!searchText) return logs;
    searchText = searchText.toLowerCase();

    return logs.filter(log =>
      Object.keys(log).some(key => {
        const value = log[key];
        if (typeof value === 'object') {
          return JSON.stringify(value).toLowerCase().includes(searchText);
        }
        return String(value).toLowerCase().includes(searchText);
      })
    );
  }
}
